export default __webpack_public_path__ + "static/media/tie_13.2fc8b738.mp3";